 
  function setPermissionsForList(dispatch, permission_type, new_button_text, new_button_url) {
    reset(dispatch);
    dispatch({type: 'set', showButtonNew: true});
    dispatch({type: 'set', showButtonSave: false});
    dispatch({type: 'set', showButtonDelete: false});
    dispatch({type: 'set', buttonNewText: new_button_text});
    dispatch({type: 'set', buttonNewUrl: new_button_url});
  }

  function setPermissionsForDetail(dispatch, save_button_text, delete_button_text, isNewRecord, cancel_url) {
    reset(dispatch);
      dispatch({type: 'set', showButtonNew: false});
      dispatch({type: 'set', showButtonSave: true});
      dispatch({type: 'set', buttonSaveText: save_button_text});  
      
      dispatch({type: 'set', showButtonCancel: true});
      dispatch({type: 'set', buttonCancelUrl: cancel_url});            
    
      dispatch({type: 'set', showButtonDelete: !isNewRecord});
      dispatch({type: 'set', buttonDeleteText: delete_button_text});   
  }

  function setPermissionsForWizard(dispatch, user_permissions, permission_type, save_button_text, delete_button_text) {
    reset(dispatch);

      dispatch({type: 'set', showButtonNew: false});
      dispatch({type: 'set', showButtonSave: true});
      dispatch({type: 'set', buttonSaveText: save_button_text});   
      dispatch({type: 'set', showButtonCancel: false});
      dispatch({type: 'set', showButtonDelete: true});    
      dispatch({type: 'set', buttonDeleteText: delete_button_text});      
    
  }

  function reset(dispatch) {
    dispatch({type: 'set', showButtonNew: false});
    dispatch({type: 'set', showButtonSave: false});
    dispatch({type: 'set', showButtonDelete: false});
    dispatch({type: 'set', isSubmitting: false});
    dispatch({type: 'set', filterFields: []});
  }
  
  export { setPermissionsForList, setPermissionsForDetail, reset, setPermissionsForWizard };